import { render, staticRenderFns } from "./investigation.vue?vue&type=template&id=ba65971a&scoped=true&"
import script from "./investigation.vue?vue&type=script&lang=js&"
export * from "./investigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba65971a",
  null
  
)

export default component.exports